
import abi from "./contract/GlobalPool.json";

import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Buy2 from "./component/buy2";
import Buy3 from "./component/buy3";
import Buy4 from "./component/buy4";
import Buy5 from "./component/buy5";
import jQuery from "jquery";
import "./css/style.css";
import "./css/bootstrap.min.css";

import "./logo.png";
import "./Global.gif";
import "./2.png";
import "./3.png";
import "./4.png";
import "./5.png";
import "./6.png";
import "./7.png";
import "./8.png";
import "./9.png";
import "./10.png";
import "./copy.png";


import { useState, useEffect } from "react";
import { ethers } from "ethers";

function App() {

  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });
  const [account, setAccount] = useState("None");
  const[b,setB]=useState("None");
  const[direct,setDirect]=useState("None");
  const[directs,setDirects]=useState("None");
  const[level,setLevel]=useState("None");
  const[auto,setAuto]=useState("None");
  const[auto1,setAuto1]=useState("None");
  const[auto2,setAuto2]=useState("None");
  const[auto3,setAuto3]=useState("None");
  const[auto4,setAuto4]=useState("None");
  const[auto5,setAuto5]=useState("None");
  const[auto6,setAuto6]=useState("None");
  const [tasks1,setTasks1] = useState([]);
  const[auto7,setAuto7]=useState("None");
  const[bonus,setBonus]=useState("None");
  const[bonus1,setBonus1]=useState("None");
  const[pack,setpackage]=useState("None");
  const[refer,setrefer]=useState("None");
const [tasks,setTasks] = useState([]);
const [total,setTotal]=useState("None");
const [req,setreq]=useState("None");
const [tt,settt]=useState("None");
const[dd,setDD]=useState("None");
const[referlink,setreflink]=useState("None");
const[bonanza,setBonanza]=useState("None");
const[bonanza1,setBonanza1]=useState("None");

const[wid,setwid]=useState("None");


  useEffect(() => {
    const connectWallet = async () => {
      const contractAddress = "0x846d0270a6c2ef27ffa8ccee480370604898f650";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
      const myParam = searchParams.get('ref');
      console.log(myParam);
      
      
      document.querySelector("#name").value=myParam;
  if(myParam == null)
  {
    document.querySelector("#name").value="0x156C720345D3816978340Bf401575D5e84d92Deb";
  }
      try {
        const { ethereum } = window;
        document.querySelector("#test").value = "Upgrade USDT 20";
        if (ethereum) {
          const account = await ethereum.request({
            method: "eth_requestAccounts",
           
          });
         
          window.ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          window.ethereum.on("accountsChanged", () => {
            
            window.location.reload();
          });

          const provider = new ethers.providers.Web3Provider(ethereum);
          try {
            const selectedNetwork = await provider.getNetwork();
          
            if (selectedNetwork.chainId !== 56) {
              await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: '0x38' }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
              });
              console.log("You have switched to the Binance network");
            } else {
              console.log("You are already on the Binance network");
            }
          } catch (switchError) {
            // The network has not been added to MetaMask
            if (switchError.code === 4902) {
              console.log("Please add the Binance network to MetaMask");
            } else {
              console.log("Cannot switch to the network");
            }
          }
          const signer = provider.getSigner();
          const contract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );
          setAccount(account);
          setState({ provider, signer, contract });
          document.querySelector("#us").value  = account[0];
          let alltasks = await contract.getMemos(account[0]);
          setTasks(alltasks);
           let alltasks1 = await contract.getMemos1(account[0]);
          setTasks1(alltasks1);

          const b =Number(alltasks[2]);
          const refer = (alltasks[1]);
         setrefer(refer);
         document.querySelector("#hid").value  = (alltasks[1]);
         const direct =Number(alltasks[2]);
         setDirect(direct);
         const directs =  Number(alltasks[22])/1000000000000000000;
         setDirects(directs);
         const level = Number(alltasks[23])/1000000000000000000;
         setLevel(level);
         const auto = Number(alltasks[11])/1000000000000000000;
         setAuto(auto);
         const auto1 = Number(alltasks[12])/1000000000000000000;
         setAuto1(auto1);
         const auto2 = Number(alltasks[13])/1000000000000000000;
         setAuto2(auto2);
         
         const auto3 = Number(alltasks[14])/1000000000000000000;
         setAuto3(auto3);
         
         const auto4 = Number(alltasks[15])/1000000000000000000;
         setAuto4(auto4);
         const auto5 = Number(alltasks[15])/1000000000000000000;
         setAuto5(auto5);
         const auto6 = Number(alltasks[16])/1000000000000000000;
         setAuto6(auto6);
        

         
         
         
         
         
         const bonus = Number(alltasks[18]);
         setBonus(bonus);
         const bonus1 = Number(alltasks[19]);
         setBonus1(bonus1);
         const total = Number(alltasks[10]);
         setTotal(total);

         const tt = directs + level + bonus + auto + total + auto1 + auto2 + auto3 + auto4 + auto5 + auto6 + auto7 + bonus1;
         settt(tt);
         
         const pack = Number(alltasks[6]);
         document.querySelector("#pp").value  = Number(alltasks[6]);
         
    
    setpackage(pack);
    const bonanza = Number(alltasks[7]);
         setBonanza(bonanza);
         const bonanza1 = Number(alltasks[20]);
         setBonanza1(bonanza1);
          const auto7 = Number(alltasks1[0]) - 1;
         setAuto7(auto7);
         
    const dd = new Date(alltasks[8].timestamp * 1000).toLocaleString();
    setDD(dd);
         setB(b);
         const referlink = 'https://bvtpro.live/?ref='+ account;
         setreflink(referlink);
         document.querySelector("#link").value =referlink;
    if(pack==20)
    { 
      document.querySelector("#test").value = "Upgrade USDT 30";
    
    }
    else if(pack==50)
    { 
      document.querySelector("#test").value = "Upgrade USDT 50";
    
    }
    else if(pack ==100)
    {
      document.querySelector("#test").value = "Upgrade USDT 100";
    }
    else if(pack ==200)
    {
      
      document.querySelector("#test").value = "Upgrade USDT 200";
    }
    else if(pack ==400)
    {
      document.querySelector("#test").value = "Upgrade USDT 400";
    }
    
    else if(pack ==800)
    {
      document.querySelector("#test").value = "Upgrade USDT 800";
    }
    else if(pack ==1600)
    {
      document.querySelector("#test").value = "Upgrade USDT 1600";
    }
    else if(pack ==3200)
    {
      document.querySelector("#test").value = "Upgrade USDT 3200";
    }
    else if(pack ==6400)
    {
      document.querySelector("#test").value = "Upgrade USDT 6400";
    }
    else if(pack == 12800)
    {

      document.querySelector("#test").value = "All Packages Purchased";
    }
    
    console.log(pack);
    
     
        } else {
          alert("Please install metamask");
        }
      } catch (error) {
        console.log(error);
      }
    };
    
     
    
    
    connectWallet();
    
  }, []);

 
  // console.log(state);
        
       
  return (
   
<div >
<input type="hidden" id ="link"></input>
    <input type="hidden" id ="hid"></input>
    <input type="hidden" id ="us"></input>
    <input type="hidden" id ="pp"></input>
     <div style={{display:"flex",justifyContent:"center",marginTop:"5rem"}} class="site-heading">
 <h4 class="sub-title">100% Fully Decenterlized Single Leg System.</h4></div>
    <div className="container mt-80 mb-80">
  <div className="row g-4">
    
 <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
           
          </div>
          <div className="box-body">
            <h2 className="amount">Total Joinings</h2>
            <p className="valuation"> {auto7} </p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon purple">
              <img src="assets/img/icon/1.png" alt="" style={{ width: "20px" }} />
            </div>
            {/* <div className="coin-info">
              <span className="pair">BTC/USD</span>
              <span className="trend up">0.17% ↗</span>
            </div> */}
          </div>
          <div className="box-body">
            <h2 className="amount">Welcome To BVTPRO :</h2>
            <p style={{wordBreak:"break-all", fontSize:"0.7rem"}} className="valuation">Connected Account: {account} </p>
            
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 25 Q 15 5, 30 20 T 60 10 T 100 20" fill="transparent" stroke="#6c5ce7" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
           
          </div>
          <div className="box-body">
            <h2 className="amount">Refer Link</h2>
            <p className="valuation">{referlink}<button><img src ="copy.png" height={"25px"} onClick={() => {
  navigator.clipboard.writeText(referlink);}} /></button></p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

   
   
     {/* BTC */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon purple">
              <img src="assets/img/icon/1.png" alt="" style={{ width: "20px" }} />
            </div>
          
          </div>
          <div className="box-body">
            <h2 className="amount">My Refer : </h2>
            <p className="valuation"> {refer}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 25 Q 15 5, 30 20 T 60 10 T 100 20" fill="transparent" stroke="#6c5ce7" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    {/* ETH */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
           
          </div>
          <div className="box-body">
            <h2 className="amount">My Total Packages</h2>
            <p className="valuation"> USDT {pack} </p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

   

    {/* BTC duplicate */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon purple">
              <img src="assets/img/icon/1.png" alt="" style={{ width: "20px" }} />
            </div>
           
          </div>
          <div className="box-body">
            <h2 className="amount">My Direct Income</h2>
            <p className="valuation"> USDT {directs}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 25 Q 15 5, 30 20 T 60 10 T 100 20" fill="transparent" stroke="#6c5ce7" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    {/* ETH duplicate */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
            
          </div>
          <div className="box-body">
            <h2 className="amount">My Direct Team</h2>
            <p className="valuation"> {direct}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

     <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
           
          </div>
          <div className="box-body">
            <h2 className="amount">Total Income</h2>
            <p className="valuation"> USDT {level}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

   
   
     {/* BTC */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon purple">
              <img src="assets/img/icon/1.png" alt="" style={{ width: "20px" }} />
            </div>
          
          </div>
          <div className="box-body">
            <h2 className="amount">level - I Income</h2>
            <p className="valuation"> USDT {auto}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 25 Q 15 5, 30 20 T 60 10 T 100 20" fill="transparent" stroke="#6c5ce7" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    {/* ETH */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
           
          </div>
          <div className="box-body">
            <h2 className="amount">level - II Income</h2>
            <p className="valuation">USDT {auto1} </p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

   

    {/* BTC duplicate */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon purple">
              <img src="assets/img/icon/1.png" alt="" style={{ width: "20px" }} />
            </div>
           
          </div>
          <div className="box-body">
            <h2 className="amount">Level - III Income</h2>
            <p className="valuation"> USDT {auto2}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 25 Q 15 5, 30 20 T 60 10 T 100 20" fill="transparent" stroke="#6c5ce7" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    {/* ETH duplicate */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
            
          </div>
          <div className="box-body">
            <h2 className="amount">Level - IV Income</h2>
            <p className="valuation">USDT {auto3}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

   
   
     {/* BTC */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon purple">
              <img src="assets/img/icon/1.png" alt="" style={{ width: "20px" }} />
            </div>
          
          </div>
          <div className="box-body">
            <h2 className="amount">Silver Royalty</h2>
            <p className="valuation"> USDT {auto5}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 25 Q 15 5, 30 20 T 60 10 T 100 20" fill="transparent" stroke="#6c5ce7" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

    {/* ETH */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
           
          </div>
          <div className="box-body">
            <h2 className="amount">Single Leg Income</h2>
            <p className="valuation"> USDT {auto6}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

   


    {/* ETH duplicate */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
            
          </div>
          <div className="box-body">
            <h2 className="amount">Current Week Direct</h2>
            <p className="valuation">  {bonus} </p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>
     <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
          <div className="box-header">
            <div className="coin-icon blue">Ξ</div>
           
          </div>
          <div className="box-body">
            <h2 className="amount">Current Week Team</h2>
            <p className="valuation">  {bonus1}</p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

   
   
   
    {/* ETH */}
    <div className="col-xl-4 col-lg-6 col-md-12">
      <div className="modern-crypto-box">
        <div className="box-content">
        
          <div className="box-body">
            <h2 className="amount"><input type ="text" style={{backgroundColor: "#fff" ,color:"black" , textAlign:"center", border :"0" ,width:"100%"} }id ="test"></input></h2>
            <p className="valuation"> <Buy state={state} /></p>
          </div>
          <div className="sparkline">
            <svg viewBox="0 0 100 30">
              <path d="M0 20 Q 20 25, 40 10 T 80 15 T 100 5" fill="transparent" stroke="#0984e3" strokeWidth="2" />
            </svg>
          </div>
        </div>
      </div>
    </div>

   

   
    

  </div>
</div>

     

 


   
       
   

   

                          
    </div>                      
    

           
                   
	




     

  );
}

export default App;
